import { Checkbox, Radio } from 'antd'
import React, { useState, useEffect, useContext } from 'react'
import registered from '../../../../src/assets/images/business1.png'
import freelancer from '../../../../src/assets/images/business2.png'
import { MultiStepFormData } from '../../Authentication/MultiStepForm/MultiStepForm'
import { useSelector } from 'react-redux'

const BusinessType = ({ getBusinessType }) => {
  const FormData = useContext(MultiStepFormData);
  const [type, setType] = useState(FormData.formData.registeredBusiness || '');
  const info = useSelector((state) => state.BusinessInfoReducer);
  let defaultInfoFlag = true;

  useEffect(() => {
    FormData.setFormData({
      ...FormData.formData,
      gstin: '',
    });
    if (info?.businessInfo?.business_type) {
      if (defaultInfoFlag) {
        setType(info?.businessInfo?.business_type)
        FormData.setFormVerified({
          ...FormData.formVerified,
          [FormData.page]: true
        });
        FormData.setFormData({
          ...FormData.formData,
          registeredBusiness: info?.businessInfo?.business_type
        });
        defaultInfoFlag = false;
      }
    }
  }, [])





  // const [value, setValue] = useState('business');
  // const [page, setPage] = useState(0);

  //   {
  //     "title": "Verify your Identity",
  //     "content": "Securely verify your identity using Aadhaar."
  // },
  // {
  //     "title": "Verify your GSTIN",
  //     "content": "Securely verify your business identity using GSTIN."
  // },

  // case 2:
  //   return <AadhaarVerification />
  // case 3:
  //   return <GstVerification />

  const onChange = (e) => {
    const selectedValue = e.target.value;
    FormData.setFormData((prevData) => ({
      ...prevData,
      registeredBusiness: selectedValue
    }));
    FormData.setFormVerified((prevVerified) => ({
      ...prevVerified,
      [FormData.page]: true
    }));
    setType(selectedValue);
  };

  // useEffect(()=>{
  //   console.log('selected value ' , selectedValue)
  // },[type])

  return (
    <div className='text-center business_type'>
      <form action="" className='form_body'>
        <Radio.Group value={type} onChange={onChange} className='business_type_group'>
          <Radio value="business">
            <div className="radio_body">
              <span>Registered <span className='lg'>Business</span></span>
              <figure><img src={registered} alt="" /></figure>
            </div>
          </Radio>
          <Radio value="freelancer">
            <div className="radio_body">
              <span>I am a <span className='lg'>Freelancer</span></span>
              <figure><img src={freelancer} alt="" /></figure>
            </div>
          </Radio>
        </Radio.Group>
      </form>
    </div>
  )
}

export default BusinessType
